import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f4c9c1da&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f4c9c1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9c1da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c9c1da')) {
      api.createRecord('f4c9c1da', component.options)
    } else {
      api.reload('f4c9c1da', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f4c9c1da&scoped=true&", function () {
      api.rerender('f4c9c1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AQ1ZkEFOiA1p/JS/comp/DocBox.vue"
export default component.exports